import React from "react";
import Header from "../header2/Header";
import { NavLink } from "react-router-dom";
import Seo from "../seo/Seo";
import { motion } from "framer-motion";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";

const Automotive = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Grank",
    url: "https://www.grank.co.in/blog",
    logo: "https://www.grank.co.in/assest/photos/g-rank-white-logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "8522953903",
      contactType: "",
      areaServed: "IN",
      availableLanguage: "en",
    },
    sameAs: [
      "https://www.facebook.com/Grank.India",
      "https://twitter.com/Grank_India/",
      "https://www.instagram.com/grank.india/",
      "https://www.youtube.com/channel/UCAuK0EC-TmLLHVSmrjxMnIA",
      "https://www.linkedin.com/company/g-rank-digital-marketing-company/",
    ],
  };

  return (
    <>
      <Seo
        title="Blog"
        description="Explore insights and tips with the G Rank blog. Stay updated on digital marketing trends, strategies, and tools."
        name="G-Rank"
        type="article"
        YahooSeeker="INDEX, FOLLOW"
        msnbot="INDEX, FOLLOW"
        googlebot="INDEX, FOLLOW"
        keywords="react, meta tags, seo"
        searchengines="ALL"
        canonical="https://www.grank.co.in/blog"
        schema={schema}
      ></Seo>

      <section className="section-top">
        <Header />
        {/* banner start */}
        <div
          className="creative-banner-display-ads"
          style={{ backgroundColor: "#fff", position: "relative" }}
        >
          <img
            className="img-fluid w-100"
            src="assest/photos/blog/blog-banner2.png"
            alt="G-Rank"
            title="blog"
          />

          <div className="blog-banner-div">
            <motion.h2
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1.5 }}
            >
              Blogs
            </motion.h2>
            <Breadcrumbs
              className=" breadcrumbs"
              aria-label="breadcrumb"
              style={{ paddingTop: "40px" }}
            >
              <NavLink
                style={({ isActive }) => ({
                  color: isActive ? "#000" : "#ccc",
                })}
                to="/"
              >
                <p>Home</p>
              </NavLink>

              <Typography color="text.primary">Blog</Typography>
            </Breadcrumbs>
          </div>
        </div>
        {/* banner end */}
        {/* images start */}
        <section className="blog-section">
          <div className="container-fluid">
            <div className="row">
              {/* New Blog 1 */}
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="/seo-assets/photos/blog/how-to-choose-the-right-digital-marketing-agency-for-your-business.png"
                    alt="How to Choose the Right Digital Marketing Agency for Your Business"
                    title="How to Choose the Right Digital Marketing Agency for Your Business"
                    style={{ borderRadius: "12px" }}
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  How to Choose the Right Digital Marketing Agency for Your Business
                </motion.h4>
                <h5>
                  The right Digital Marketing Agency can make a huge difference to your online visibility, lead generation, brand growth and revenue. Hundreds of agencies are offering SEO, Google Ads, social media marketing, content marketing &amp; web solutions...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/how-to-choose-the-right-digital-marketing-agency-for-your-business"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>

              {/* New Blog 2 */}
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="/seo-assets/photos/blog/how-ai-is-transforming-digital-marketing-in-2026.png"
                    alt="How AI Is Transforming Digital Marketing in 2026"
                    title="How AI Is Transforming Digital Marketing in 2026"
                    style={{ borderRadius: "12px" }}
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  How AI Is Transforming Digital Marketing in 2026
                </motion.h4>
                <h5>
                  AI has moved from emerging technology to a big part of modern marketing. Discover how AI is revolutionizing SEO, hyper-personalization, content creation, smart advertising, and marketing automation in 2026...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/how-ai-is-transforming-digital-marketing-in-2026"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>

              {/* New Blog 3 */}
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="/seo-assets/photos/blog/seo-vs-ppc-which-is-better-for-business-growth.png"
                    alt="SEO vs PPC: Which Is Better for Business Growth?"
                    title="SEO vs PPC: Which Is Better for Business Growth?"
                    style={{ borderRadius: "12px" }}
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  SEO vs PPC: Which Is Better for Business Growth?
                </motion.h4>
                <h5>
                  SEO vs PPC is a comparison between two search marketing strategies that every business considers. Compare costs, speed, long-term ROI, and discover how to build an integrated search marketing engine...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/seo-vs-ppc-which-is-better-for-business-growth"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>

              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="assest/photos/blog/blog-img1.jpg"
                    alt="G-Rank"
                    title="blog"
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  Everyone wants a home, right? Yet, selling a home is not
                  child's play.
                </motion.h4>
                <h5>
                  Much has happened in 2022. With the industry constantly
                  changing, it is vital to level up the game and tap into
                  competitive marketing. Among all techniques, a digital
                  footprint is a modern way to capture the interest and engage
                  with potential buyers...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/top-real-estate-digital-marketing-tips"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="assest/photos/blog/blog-img2.jpg"
                    alt="G-Rank"
                    title="blog"
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  Yes, digital marketing is essential for the success of any
                  business. But does it suffice? Honestly, no.
                </motion.h4>
                <h5>
                  Have you ever thought about why big businesses focus on brand
                  value? Because adding an extra dosage of branding is necessary
                  for quality business growth. Like two peas in a pod, branding
                  and...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/blog-second"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="assest/photos/blog/blog-img3.jpg"
                    alt="G-Rank"
                    title="blog"
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  Search Engine Optimization & Pay Per Click Are Effective For
                  Brands
                </motion.h4>
                <h5>
                  Are you also curious how search engine optimization & pay per
                  click are effective for brands? Moreover, can they work
                  together? It’s usual for tons of doubts to pop into your head
                  in this adventurous web world. The answer is yes, though...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/blog-third"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="assest/photos/blog/blog-img4.jpg"
                    alt="G-Rank"
                    title="blog"
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  How To Improve Your Seo With User-Friendly Interlinking
                </motion.h4>
                <h5>
                  Given the volume of material on the plate, it’s inevitable to
                  get mixed in this tricky system. Do not worry, we have an
                  Interlinking remedy for this. Call it a technique or a
                  hack,...
                </h5>

                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/blog-four"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>
              <div className="col-12 col-md-6 col-lg-6 blog-images-section">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  <img
                    className="img-fluid w-100"
                    src="assest/photos/blog/blog-img5.jpg"
                    alt="G-Rank"
                    title="blog"
                  />
                </motion.div>
                <motion.h4
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 1.2 }}
                >
                  7 tips for helping you increase organic traffic
                </motion.h4>
                <h5>
                  Are you also constantly creating A1 content? It is upsetting
                  that we aren't getting organic traffic despite our best
                  efforts and never-ending work on our products and services...
                </h5>
                <NavLink
                  style={({ isActive }) => ({
                    color: isActive ? "#000" : "#000",
                  })}
                  to="/blog-five"
                >
                  <span>
                    <h2>Read More...</h2>
                  </span>
                </NavLink>
              </div>
            </div>
          </div>
        </section>
        {/* images end */}
      </section>
    </>
  );
};

export default Automotive;
